import { useNavigate } from 'react-router-dom';

import { ButtonProps } from 'components/button';

import { formatViewObjectsPhrase } from 'lib/utils';
import { BuyApartmentFlowPaths } from 'routes';
import useApartmentsFilterLimitsOnboarding from 'api/hooks/use-apartment-filter-limits-onboarding';

const useViewApartmentDealsButtonProps = (
  enabled = true,
  tab?: number,
): Pick<ButtonProps, 'label' | 'onClick' | 'variant' | 'loading' | 'disabled'> => {
  const navigate = useNavigate();
  const { count, isLoading } = useApartmentsFilterLimitsOnboarding(enabled);

  return {
    variant: 'gray',
    disabled: isLoading || count === undefined,
    loading: isLoading,
    label: isLoading ? 'Загрузка' : formatViewObjectsPhrase(count),
    onClick() {
      if (count !== 0)
        navigate(
          BuyApartmentFlowPaths.aparmentDeals, //need improve it
          tab === 1 ? { state: { prevScreen: 'map' } } : undefined,
        );
    },
  };
};

export default useViewApartmentDealsButtonProps;
